import { formatDateDDmmmYYYY } from '@/helpers/dateUtiles';
import i18n from '@/i18n';

const { t } = i18n.global;

export const obtenerPoliticasCancelacion = (informacionHabitaciones, multiplesHabitaciones = true) => {
  let textoPoliticas = `<p>${t('reserva.condicionesReserva')}</p>`;

  if (multiplesHabitaciones) {
    informacionHabitaciones.map((habitacion, index) => {
      textoPoliticas += `<h4 class='text-secondary'>${t('general.habitacion')} ${index + 1}</h4>`;
      textoPoliticas += `<p>${habitacion.politicaCancelacion?.nombre}</p>`;
      textoPoliticas += `<p>${t('reserva.costesAsociadosReserva')}</p><ul>`;

      habitacion.politicaCancelacion?.tramos?.map(tramo => {
        textoPoliticas += `<li>${t('general.el')} ${tramo.porcentaje}% ${t(
          'reserva.cancelacionEntre'
        )} ${formatDateDDmmmYYYY(tramo.fechaInicio)} ${t('general.y')} ${t('general.antesDel')} ${formatDateDDmmmYYYY(
          tramo.fechaFin
        )}</li>`;
      });
      textoPoliticas += '</ul>';
    });
  } else {
    textoPoliticas += `<p>${informacionHabitaciones.politicaCancelacion?.nombre}</p>`;
    textoPoliticas += `<p>${t('reserva.costesAsociadosReserva')}</p><ul>`;

    let numTramos = informacionHabitaciones.politicaCancelacion?.tramos.length;
    informacionHabitaciones.politicaCancelacion?.tramos?.map((tramo, indexTramo) => {
      textoPoliticas += `<li>${t('general.el')} ${tramo.porcentaje}% ${t(
        'reserva.cancelacionEntre'
      )} ${formatDateDDmmmYYYY(tramo.fechaInicio)} ${t('general.y')} ${
        indexTramo == numTramos - 1 ? t('general.antesDel') : t('general.el').toLowerCase()
      } ${formatDateDDmmmYYYY(tramo.fechaFin)}</li>`;
    });
    textoPoliticas += '</ul>';
  }

  return textoPoliticas;
};

export function truncateDescription(html, maxLength) {
  if (!html) return '';
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const plainText = doc.body.textContent || '';
  if (plainText.length <= maxLength) return html;

  let count = 0;
  let result = '';
  const tags = [];

  function escapeAttr(value) {
    return value.replace(/"/g, '&quot;');
  }

  function walk(node) {
    if (count >= maxLength) return;
    if (node.nodeType === 3) {
      const text = node.textContent || '';
      const remaining = maxLength - count;
      if (text.length <= remaining) {
        result += text;
        count += text.length;
      } else {
        result += text.substring(0, remaining) + '...';
        count = maxLength;
      }
    } else if (node.nodeType === 1) {
      const tag = node.tagName.toLowerCase();
      const attrs = Array.from(node.attributes)
        .map(a => {
          const value = escapeAttr(a.value);
          return `${a.name}="${value}"`;
        })
        .join(' ');
      result += `<${tag}${attrs ? ' ' + attrs : ''}>`;
      tags.push(tag);
      for (const child of node.childNodes) {
        if (count >= maxLength) break;
        walk(child);
      }
      if (count < maxLength || tags[tags.length - 1] === tag) {
        result += `</${tag}>`;
        tags.pop();
      }
    }
  }

  for (const child of doc.body.childNodes) {
    if (count >= maxLength) break;
    walk(child);
  }
  while (tags.length) result += `</${tags.pop()}>`;
  return result;
}
